import React, { useState } from 'react';
import { waLink, trackLead } from '../lib/whatsapp';
import { CTA_LABEL, IMAGES, eventTypes, guestRanges, WHATSAPP_DISPLAY } from '../data/site';

const fieldClass =
  'w-full rounded-xl border border-ink/20 bg-page px-4 py-3.5 text-base text-ink placeholder:text-soft focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30';

const formatDate = (iso) => (iso ? iso.split('-').reverse().join('/') : '');

const Field = ({ label, id, children, error }) => (
  <div className="flex flex-col gap-2">
    <label htmlFor={id} className="text-sm font-medium">
      {label}
    </label>
    {children}
    {error && (
      <p id={`${id}-error`} className="text-sm font-medium text-red-400">
        {error}
      </p>
    )}
  </div>
);

const QuoteForm = () => {
  const [form, setForm] = useState({ name: '', type: '', date: '', city: '', guests: '' });
  const [errors, setErrors] = useState({});
  const update = (key) => (e) => {
    setForm({ ...form, [key]: e.target.value });
    if (errors[key]) setErrors({ ...errors, [key]: null });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!form.type) nextErrors.type = 'Escolha o tipo de evento.';
    if (!form.date) nextErrors.date = 'Informe a data, mesmo que aproximada.';
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    const message = [
      `Olá, Paulo! Vim pelo site${form.name ? `, sou ${form.name}` : ''}. Quero um orçamento.`,
      '',
      `Tipo de evento: ${form.type}`,
      `Data: ${formatDate(form.date)}`,
      `Local/cidade: ${form.city}`,
      `Nº de convidados: ${form.guests}`,
    ].join('\n');
    trackLead('form', { event_type: form.type, guests: form.guests });
    window.open(waLink(message), '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="orcamento" data-testid="quote-section" className="px-4 pb-24 md:px-8 md:pb-28">
      <div className="mx-auto grid max-w-7xl overflow-hidden rounded-2xl bg-raised lg:grid-cols-2">
        <div className="relative hidden min-h-[520px] lg:block">
          <img src={IMAGES.setup.src} alt={IMAGES.setup.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        </div>

        <div className="p-6 sm:p-10 lg:p-14">
          <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl">Sua data ainda está livre?</h2>
          <p className="mt-4 max-w-[44ch] text-lg text-soft">Preencha em 30 segundos. Abre o WhatsApp com a mensagem pronta, sem compromisso.</p>

          <form onSubmit={handleSubmit} noValidate className="mt-8 grid gap-5 sm:grid-cols-2" data-testid="quote-form">
            <Field label="Tipo de evento" id="type" error={errors.type}>
              <select id="type" value={form.type} onChange={update('type')} className={fieldClass} aria-invalid={!!errors.type} aria-describedby={errors.type ? 'type-error' : undefined}>
                <option value="">Selecione</option>
                {eventTypes.map((t) => (
                  <option key={t}>{t}</option>
                ))}
              </select>
            </Field>
            <Field label="Data do evento" id="date" error={errors.date}>
              <input id="date" type="date" value={form.date} onChange={update('date')} className={fieldClass} aria-invalid={!!errors.date} aria-describedby={errors.date ? 'date-error' : undefined} />
            </Field>
            <Field label="Cidade ou local" id="city">
              <input id="city" type="text" value={form.city} onChange={update('city')} placeholder="Ex.: Guarulhos" className={fieldClass} />
            </Field>
            <Field label="Convidados" id="guests">
              <select id="guests" value={form.guests} onChange={update('guests')} className={fieldClass}>
                <option value="">Selecione</option>
                {guestRanges.map((g) => (
                  <option key={g}>{g}</option>
                ))}
              </select>
            </Field>
            <div className="sm:col-span-2">
              <Field label="Seu nome (opcional)" id="name">
                <input id="name" type="text" value={form.name} onChange={update('name')} className={fieldClass} autoComplete="given-name" />
              </Field>
            </div>

            <div className="flex flex-col gap-4 sm:col-span-2 sm:flex-row sm:items-center">
              <button
                type="submit"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-accent px-7 py-4 text-base font-semibold text-accent-ink transition-transform hover:-translate-y-px active:scale-[0.98]"
                data-testid="quote-submit"
              >
                {CTA_LABEL}
              </button>
              <p className="text-sm text-soft">
                Ou ligue: <span className="font-medium text-ink">{WHATSAPP_DISPLAY}</span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default QuoteForm;
